/* eslint-disable react/prop-types */
import React from 'react';
import {
    Box,
    Grid,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Button,
    TextField,
    FormLabel,
    Typography,
    Autocomplete
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import { gridSpacing } from 'store/constant';
import { Delete } from '@mui/icons-material';
import { greenBuildingVerificationTypeOptions, greenEnergyEfficient, GreenSustainability } from './data/greenEnergy_data';
import { FieldArray } from 'formik';
import { tips } from './HelpData';
import HelpIcon from './HelpIcon';

const GreenEnergy = ({
    errors,
    handleChange,
    handleBlur,
    values,
    touched,
    setFieldValue,
    deleteGreenEnergyBuildingListings,
    dispatch,
    isDuplicate,
    id,
    openSnackbar
}) => (
    <Grid item xs={12}>
        <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
                <Typography
                    sx={{
                        color: '#919191',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: 'normal',
                        textTransform: 'capitalize',
                        m: 3
                    }}
                >
                    Energy, Environment and Sustainability Information
                </Typography>
                <SubCard>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth error={touched.greenEnergyEfficient && Boolean(errors.greenEnergyEfficient)}>
                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                            Green Energy Efficient
                                        </Typography>
                                    </FormLabel>

                                    <HelpIcon
                                        title={tips?.greenEnergyEfficient?.title}
                                        ruleHelp={tips?.greenEnergyEfficient?.ruleHelp}
                                        generalHelpDesc={tips?.greenEnergyEfficient?.generalHelpDesc}
                                        generalHelp={tips?.greenEnergyEfficient?.generalHelp}
                                    />
                                </Box>
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={greenEnergyEfficient}
                                    value={values.greenEnergyEfficient || []}
                                    onChange={(event, newValue) => {
                                        setFieldValue('greenEnergyEfficient', newValue);
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Green Energy Efficient" fullWidth />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox checked={selected} sx={{ mr: 1 }} />
                                            <ListItemText primary={option} />
                                        </li>
                                    )}
                                />

                                {touched.greenEnergyEfficient && errors.greenEnergyEfficient && (
                                    <FormHelperText>{errors.greenEnergyEfficient}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth error={touched.greenSustainability && Boolean(errors.greenSustainability)}>
                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                            Green Sustainability
                                        </Typography>
                                    </FormLabel>
                                    <HelpIcon
                                        title={tips?.greenSustainability?.title}
                                        ruleHelp={tips?.greenSustainability?.ruleHelp}
                                        generalHelpDesc={tips?.greenSustainability?.generalHelpDesc}
                                        generalHelp={tips?.greenSustainability?.generalHelp}
                                    />
                                </Box>
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={GreenSustainability}
                                    value={values.greenSustainability || []}
                                    onChange={(event, newValue) => {
                                        setFieldValue('greenSustainability', newValue);
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Green Sustainability" fullWidth />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox checked={selected} sx={{ mr: 1 }} />
                                            <ListItemText primary={option} />
                                        </li>
                                    )}
                                />

                                {touched.greenSustainability && errors.greenSustainability && (
                                    <FormHelperText>{errors.greenSustainability}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Typography variant="h4" fontWeight="bold" component="span" sx={{ m: 2, mt: 4, mb: 1 }}>
                            Green Energy
                        </Typography>

                        <Grid item xs={12} sm={12} sx={{ m: '16px', p: '16px' }}>
                            <FieldArray name="greenEnergyVerification" sx={{ m: 0 }}>
                                {({ push, remove }) => (
                                    <Grid container spacing={2}>
                                        {values.greenEnergyVerification.map((_, index) => (
                                            <Box
                                                sx={{
                                                    borderBottom: '1px solid #9f9f9f',
                                                    width: '100%',
                                                    p: 2,
                                                    mb: 3
                                                }}
                                                key={index}
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={5}>
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Green Building Verification Type
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.greenEnergyVerification?.title}
                                                                ruleHelp={tips?.greenEnergyVerification?.ruleHelp}
                                                                generalHelpDesc={tips?.greenEnergyVerification?.generalHelpDesc}
                                                                generalHelp={tips?.greenEnergyVerification?.generalHelp}
                                                            />
                                                        </Box>

                                                        <TextField
                                                            fullWidth
                                                            name={`greenEnergyVerification[${index}].greenEnergyBuildingVerificationType`}
                                                            value={
                                                                values.greenEnergyVerification[index].greenEnergyBuildingVerificationType
                                                            }
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.greenEnergyVerification?.[index]
                                                                    ?.greenEnergyBuildingVerificationType &&
                                                                Boolean(
                                                                    errors.greenEnergyVerification?.[index]
                                                                        ?.greenEnergyBuildingVerificationType
                                                                )
                                                            }
                                                        />

                                                        {touched.greenEnergyVerification?.[index]?.greenEnergyBuildingVerificationType &&
                                                            errors.greenEnergyVerification?.[index]
                                                                ?.greenEnergyBuildingVerificationType && (
                                                                <FormHelperText error>
                                                                    {
                                                                        errors.greenEnergyVerification[index]
                                                                            .greenEnergyBuildingVerificationType
                                                                    }
                                                                </FormHelperText>
                                                            )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={5}>
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Verification Metric
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.verificationMetric?.title}
                                                                ruleHelp={tips?.verificationMetric?.ruleHelp}
                                                                generalHelpDesc={tips?.verificationMetric?.generalHelpDesc}
                                                                generalHelp={tips?.verificationMetric?.generalHelp}
                                                            />
                                                        </Box>
                                                        <TextField
                                                            fullWidth
                                                            name={`greenEnergyVerification[${index}].verificationMetric`}
                                                            value={values.greenEnergyVerification[index].verificationMetric}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.greenEnergyVerification?.[index]?.verificationMetric &&
                                                                Boolean(errors.greenEnergyVerification?.[index]?.verificationMetric)
                                                            }
                                                        />

                                                        {touched.greenEnergyVerification?.[index]?.verificationMetric &&
                                                            errors.greenEnergyVerification?.[index]?.verificationMetric && (
                                                                <FormHelperText error>
                                                                    {errors.greenEnergyVerification[index].verificationMetric}
                                                                </FormHelperText>
                                                            )}
                                                    </Grid>

                                                    <Grid item xs={12} sm={1} />

                                                    <Grid item xs={12} sm={1}>
                                                        <Button
                                                            onClick={() => {
                                                                if (values.greenEnergyVerification.length > 1) {
                                                                    remove(index);
                                                                    if (id !== 'add' && !isDuplicate) {
                                                                        if (values.greenEnergyVerification[index]?.id) {
                                                                            dispatch(
                                                                                deleteGreenEnergyBuildingListings(
                                                                                    values.greenEnergyVerification[index]?.id
                                                                                )
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            variant="contained"
                                                            sx={{
                                                                border: '1px solid red',
                                                                background: 'white',
                                                                color: 'red',
                                                                display: 'flex',
                                                                justifyContent: 'center', // Center content horizontally
                                                                alignItems: 'center' // Center content vertically
                                                            }}
                                                        >
                                                            <Delete />
                                                        </Button>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Verification Status
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.verificationStatus?.title}
                                                                ruleHelp={tips?.verificationStatus?.ruleHelp}
                                                                generalHelpDesc={tips?.verificationStatus?.generalHelpDesc}
                                                                generalHelp={tips?.verificationStatus?.generalHelp}
                                                            />
                                                        </Box>
                                                        <TextField
                                                            fullWidth
                                                            name={`greenEnergyVerification[${index}].verificationStatus`}
                                                            value={values.greenEnergyVerification[index].verificationStatus}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.greenEnergyVerification?.[index]?.verificationStatus &&
                                                                Boolean(errors.greenEnergyVerification?.[index]?.verificationStatus)
                                                            }
                                                        />

                                                        {touched.greenEnergyVerification?.[index]?.verificationStatus &&
                                                            errors.greenEnergyVerification?.[index]?.verificationStatus && (
                                                                <FormHelperText error>
                                                                    {errors.greenEnergyVerification[index].verificationStatus}
                                                                </FormHelperText>
                                                            )}
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Verification Rating
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.verificationRating?.title}
                                                                ruleHelp={tips?.verificationRating?.ruleHelp}
                                                                generalHelpDesc={tips?.verificationRating?.generalHelpDesc}
                                                                generalHelp={tips?.verificationRating?.generalHelp}
                                                            />
                                                        </Box>
                                                        <TextField
                                                            fullWidth
                                                            name={`greenEnergyVerification[${index}].verificationRating`}
                                                            value={values.greenEnergyVerification[index].verificationRating}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.greenEnergyVerification?.[index]?.verificationRating &&
                                                                Boolean(errors.greenEnergyVerification?.[index]?.verificationRating)
                                                            }
                                                        />

                                                        {touched.greenEnergyVerification?.[index]?.verificationRating &&
                                                            errors.greenEnergyVerification?.[index]?.verificationRating && (
                                                                <FormHelperText error>
                                                                    {errors.greenEnergyVerification[index].verificationRating}
                                                                </FormHelperText>
                                                            )}
                                                    </Grid>

                                                    <Grid item xs={12} sm={4}>
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Verification Year
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.verificationYear?.title}
                                                                ruleHelp={tips?.verificationYear?.ruleHelp}
                                                                generalHelpDesc={tips?.verificationYear?.generalHelpDesc}
                                                                generalHelp={tips?.verificationYear?.generalHelp}
                                                            />
                                                        </Box>
                                                        <TextField
                                                            fullWidth
                                                            name={`greenEnergyVerification[${index}].verificationYear`}
                                                            value={values.greenEnergyVerification[index].verificationYear}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.greenEnergyVerification?.[index]?.verificationYear &&
                                                                Boolean(errors.greenEnergyVerification?.[index]?.verificationYear)
                                                            }
                                                        />

                                                        {touched.greenEnergyVerification?.[index]?.verificationYear &&
                                                            errors.greenEnergyVerification?.[index]?.verificationYear && (
                                                                <FormHelperText error>
                                                                    {errors.greenEnergyVerification[index].verificationYear}
                                                                </FormHelperText>
                                                            )}
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        ))}
                                        <Button
                                            onClick={() => {
                                                const val = values.greenEnergyVerification.length - 1; // get the last index

                                                if (
                                                    values.greenEnergyVerification[val].verificationMetric.length &&
                                                    values.greenEnergyVerification[val].verificationStatus &&
                                                    values.greenEnergyVerification[val].verificationRating &&
                                                    values.greenEnergyVerification[val].verificationYear
                                                ) {
                                                    push({
                                                        verificationMetric: '',
                                                        verificationStatus: '',
                                                        verificationRating: '',
                                                        verificationYear: ''
                                                    });
                                                } else {
                                                    dispatch(
                                                        openSnackbar({
                                                            open: true,
                                                            message: `Please fill above details`,
                                                            variant: 'alert',
                                                            alert: {
                                                                color: 'error'
                                                            },
                                                            close: true
                                                        })
                                                    );
                                                }
                                            }}
                                            variant="contained"
                                            sx={{ background: '#0a66c2', py: 1.25 }}
                                        >
                                            Add More
                                        </Button>
                                    </Grid>
                                )}
                            </FieldArray>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>

            {errors.submit && (
                <Grid item xs={12}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
            )}
        </Grid>
    </Grid>
);

export default GreenEnergy;
